export enum TrajectoryStage {
    Departure = 'Departure',
    Arrival = 'Arrival',
    Mission = 'Mission',
    VertiportArrival = 'VertiportArrival',
    DeliveryRoute = 'DeliveryRoute',
    ReturnRoute = 'ReturnRoute',
    DeliveryArrival = 'DeliveryArrival',
    DeliveryDeparture = 'DeliveryDeparture',
    Loiter = 'Loiter',
    Land = 'Land',
}